import React from 'react';
import {Router} from '@reach/router';
import {Helmet} from 'react-helmet';

import {Accounts, Billing, NavLink, Practice} from './components';

import * as styles from './Settings.module.css';

export function Settings() {
  return (
    <div>
      <Helmet title="Settings" />

      <h1>Settings</h1>

      <nav className={styles.Nav}>
        <NavLink to="./">Practice</NavLink>
        <NavLink to="billing">Billing and payouts</NavLink>
        <NavLink to="accounts">Accounts</NavLink>
      </nav>

      <Router primary={false}>
        <Practice path="/" />
        <Billing path="billing" />
        <Accounts path="accounts" />
      </Router>
    </div>
  );
}
